export const SHAPES = {
  A: {
    path: 'M375 0H0V12C129.5 -14.5 175.5 12 265.5 12C355.5 12 375 0 375 0Z',
    height: 12,
  },
  B: {
    path: 'M375 0H0V6C132.5 30.5 165.5 6 255.5 6C345.5 6 375 0 375 0Z',
    height: 17,
  },
  C: {
    path: 'M375 0H0V30.4501C0 30.4501 68.5 16.5175 165.5 39.6267C262.5 62.7359 300 55.0926 375 2.93628V0Z',
    height: 52,
  },
  D: {
    path: 'M375 0H0V6.45006C0 6.45006 72.5 40 165.5 15.6267C258.5 -8.74655 315.5 72.5 375 2.93628V0Z',
    height: 32,
  },
  E: {
    path: 'M375 0H0V6.45006C0 6.45006 135.5 -9.49997 198.5 19C261.5 47.5 205.5 6.45006 375 2.93628V0Z',
    height: 30,
  },
  F: {
    path: 'M0 0H375V12C245.5 -14.5 199.5 12 109.5 12C19.5 12 0 0 0 0Z',
    height: 12,
  },
}
